import apiClient from '@u/apiClient'
import router from '@/router'

import DossierAttachmentsActions from './dossier_attachments/actions'
import DossierPictureActions from './dossier_picture/actions'
import DossierItemsActions from './dossier_items/actions'
import DossierPartnersActions from './dossier_partners/actions'
import DossierFamilySpaceActions from './dossier_family_space/actions'
import DossierPersonActions from './dossier_person/actions'
import DossierPropertiesActions from './dossier_properties/actions'
import DossierSectionUpdateActions from './dossierSectionUpdate/action'
import DossierTaskActions from './dossier_task/actions'
import DossierMailboxActions from './dossier_mailbox/actions'
import OldGetDossierListsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/OldGetDossierListsController'
import GetDossierListController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierListController'
import GetDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierByIdController'
import DeleteDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/DeleteDossierController'
import ConvertDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ConvertDossierController'
import ManageItemStockDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ManageItemStockDossierController'
import TransfertDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/TransfertDossierController'
import DuplicateDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/DuplicateDossierController'
import FetchItemComponentsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ItemDossier/FetchItemComponentsController'
import GetDossierSupplierOrderController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierSupplierOrderController'
import ReorderDossierTasksController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ReorderDossierTasksController'
import GetTasksDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetTasksDossierByIdController'
import FetchContactDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchContactDossierByIdController'
import FetchInvoiceDossierForSelectByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchInvoiceDossierForSelectByIdController'
import FetchItemCategoriesDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchItemCategoriesDossierByIdController'
import FetchTransfertsDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchTransfertsDossierByIdController'
import FetchCeremoniesDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchCeremoniesDossierByIdController'
import GetDossierActivitiesByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierActivitiesByIdController'
import FetchDocumentsDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchDocumentsDossierByIdController'
import GetAvailableEventTypeDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetAvailableEventTypeDossierByIdController'
import GetListDocumentDossierController from '@/wayfinder/actions/App/Http/Controllers/Document/GetListDocumentDossierController'
import GetDossierInvoicesController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierInvoicesController'
import GetDossierItemsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierItemsController'
import SettingsForManagementOfDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/SettingsForManagementOfDossierByIdController'
import GetDossierAutomationsDebugController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierAutomationsDebugController'
import GetPaymentByDossierIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetPaymentByDossierIdController'
import ExportDossierFormController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ExportDossierFormController'
import CreateDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/CreateDossierController'
import UpdateDossierStatusController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierStatusController'
import UpdateDossierStatusCompletedController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierStatusCompletedController'
import RunAutomationDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/RunAutomationDossierController'
import AssignGravePlotToDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/AssignGravePlotToDossierController'
import UnlinkDossierPaymentController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UnlinkDossierPaymentController'
import FetchCondolencesDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/Condolence/FetchCondolencesDossierByIdController'
import GetDossierStatusIndicatorsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetDossierStatusIndicatorsController'
import GetEventByIdController from '@/wayfinder/actions/App/Http/Controllers/Agenda/GetEventByIdController'
import { apiPath } from '@u/apiPath'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'
import UpdateDossierDocumentStatusController from '@/wayfinder/actions/App/Http/Controllers/Dossier/UpdateDossierDocumentStatusController'
import type {
  MandatoryDocument,
  MandatoryDocumentStatus
} from '@/views/dossier/form/subpages/documents/mandatoryDocuments'

//const base_errors = { deceased: {}, events: [] }
const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  ...DossierAttachmentsActions,
  ...DossierItemsActions,
  ...DossierPartnersActions,
  ...DossierPersonActions,
  ...DossierPropertiesActions,
  ...DossierSectionUpdateActions,
  ...DossierTaskActions,
  ...DossierAttachmentsActions,
  ...DossierPictureActions,
  ...DossierPictureActions,
  ...DossierFamilySpaceActions,
  ...DossierMailboxActions,
  // #region fetch

  async oldFetchDossierList({ commit }, payload) {
    // const queryString = new URLSearchParams(Object.entries(payload)).toString()
    await apiClient
      .route(OldGetDossierListsController.post(), payload)
      .then(async (response) => {
        await commit('setDossierList', response.data.dossiers)
        await commit(
          'dashboard/setCurrentTemplateColumnList',
          response.data.metadata,
          {
            root: true
          }
        )
        processSuccessCallback(payload)
      })
      .catch(async (reason) => {
        await console.error('fetchDossierList', reason)
      })
  },

  async fetchArchivedDossierList({ commit }, payload) {
    await apiClient
      .route(
        GetDossierListController.get({ query: { status: payload.status } })
      )
      .then(async (response) => {
        await commit('setDossierList', response.data.dossiers)
        await commit('setDossierMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        await console.error('fetchArchivedDossierList', reason)
      })
  },

  fetchDossierList: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetDossierListController.get(), {
          params: payload
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchDossier: ({ commit, dispatch }, id) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetDossierByIdController.get({ dossier: id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  deleteDossier: ({ commit, dispatch }, id) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DeleteDossierController.delete({ dossier: id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  convertDossier: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ConvertDossierController.post({ dossier: payload.id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  manageStockItemDossier: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ManageItemStockDossierController.post({ dossier: payload.id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  transferDossier: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          TransfertDossierController.post({ dossier: payload.id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  duplicateDossier: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DuplicateDossierController.post({ dossier: payload.id }),
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchDossierByID({ commit, dispatch }, id) {
    if (!id) {
      return
    }
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetDossierByIdController.get({ dossier: id }))
        .then((response) => {
          if (response.status === 200) {
            dispatch(
              'metadata/setCurrentGlobalForm',
              {
                funeral_home_id: response.data.dossier.funeral_home_id
              },
              { root: true }
            )
            commit('setInitialDossier', response.data.dossier)
            commit('setDossier', response.data.dossier)
            commit('setDossierMetadata', response.data.metadata)
            commit('auth/setErrors', base_errors, { root: true })
            if (!response.data.dossier.events) {
              commit('setDossierEventsKey')
            }
            if (!response.data.dossier.properties) {
              commit('setDossierProperties')
            }
            if (!response.data.dossier.items) {
              commit('setDossierItems', [])
            }
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchItemComponentsByItemID({ commit, dispatch }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchItemComponentsController.get({
            dossier: payload.dossier_id,
            item: payload.item_id
          }),
          {
            params: payload.funeral_home_id
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchSupplierOrderByDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDossierSupplierOrderController.get({ dossier: payload.dossier_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchTasksByDossierID({ commit, dispatch }, id) {
    if (!id) {
      return
    }
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetTasksDossierByIdController.get({ dossier: id }))
        .then((response) => {
          if (response.status === 200) {
            commit('setTasksDossier', response.data.tasks)
          }
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  reorderDossierTasks({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ReorderDossierTasksController.put({ dossier: payload.dossierId }),
          { ordered_ids: payload.orderedIds }
        )
        .then((response) => resolve(response.data))
        .catch((reason) => reject(reason))
    })
  },
  async fetchNewDossier({ commit }) {
    commit('setDossier', { deceased: {}, dossier_items: [] })
    commit('auth/setErrors', base_errors, { root: true })

    await commit('setDossier', {})
    await commit('setDossierMetadata', {})

    await apiClient
      .route(GetNewModelController.get({ query: { model: 'dossier' } }))
      .then(async (response) => {
        if (response.status === 200) {
          await commit('setDossier', response.data.dossier)
          await commit('setDossierMetadata', response.data.metadata)
          await commit('resetDossierConcernedPerson')
        }
      })
      .catch(async (reason) => {
        await console.error('fetchNewDossier', reason)
      })

    // await apiClient
    //   .get('model/new?model=dossier')
    //   .then(async (response) => {
    //     await commit('auth/setErrors', base_errors, { root: true })
    //     await commit('setDossier', {
    //       ...response.data.dossier,
    //       deceased: {},
    //       events: []
    //     })
    //     await commit('setDossierMetadata', response.data.metadata)
    //     await commit('replaceContact')
    //   })
    //   .catch(async (reason) => {
    //     await console.error('fetchNewDossier', reason)
    //   })
  },
  fetchContactDossierList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchContactDossierByIdController.get({
            dossier: payload.dossier_id
          }),
          {
            params: payload.params
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  fetchInvoiceDossierList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchInvoiceDossierForSelectByIdController.get({
            dossier: payload.dossier_id
          }),
          {
            params: payload.params
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  fetchItemCategoriesDossierList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchItemCategoriesDossierByIdController.get({
            dossier: payload.dossier_id
          }),
          {
            params: payload.params
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async fetchTransfertsDossierList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchTransfertsDossierByIdController.get({
            dossier: payload.dossier_id
          }),
          {
            params: payload.params
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async fetchCeremoniesDossierList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchCeremoniesDossierByIdController.get({
            dossier: payload.dossier_id
          }),
          {
            params: payload.params
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async fetchVisitsDossierList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchCeremoniesDossierByIdController.get({
            dossier: payload.dossier_id
          }),
          {
            params: payload.params
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  fetchDossierActivities({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDossierActivitiesByIdController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchAllDocumentAttachedToDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchDocumentsDossierByIdController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  getAvailableEventTypeOfDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetAvailableEventTypeDossierByIdController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  fetchDocumentsList: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetListDocumentDossierController.get({ dossier: payload.dossier_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  /**
   * Sets by hand the follow-up of a mandatory document on a dossier ("to_do"
   * clears the manual choice) and resolves with the dossier's mandatory
   * documents, recomputed.
   */
  updateDocumentStatus: (
    { commit },
    {
      dossier_id,
      document_id,
      status
    }: {
      dossier_id: string
      document_id: string
      status: MandatoryDocumentStatus
    }
  ): Promise<MandatoryDocument[]> => {
    return apiClient
      .route(
        UpdateDossierDocumentStatusController.put({
          dossier: dossier_id,
          document: document_id
        }),
        { status }
      )
      .then((response) => response.data.mandatory_documents)
  },
  fetchInvoicesList: ({ commit }, { dossier_id, doc_type }) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetDossierInvoicesController.get({ dossier: dossier_id }), {
          params: {
            doc_type
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchDossierItemsList: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetDossierItemsController.get({ dossier: payload.dossier_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchSettingsManagementDossier: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SettingsForManagementOfDossierByIdController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchDossierAutomationsDebug: (_, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDossierAutomationsDebugController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchPaymentDossierById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetPaymentByDossierIdController.get({
            dossier: payload.dossier_id,
            payment: payload.payment_id
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  exportDossierForm: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ExportDossierFormController.get({ dossier: payload.dossier_id }),
          {
            responseType: 'blob'
          }
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  // #endregion

  // #region store

  async storeNewDossier({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(CreateDossierController.post(), payload.dossier)
      .then(async (response) => {
        console.log(response.status)
        if (response.status === 201) {
          commit('setEditionMode', true)
          if (payload.type === 'normal') {
            await router.push({
              name: 'dossier_form_information_route_edit',
              params: { id: response.data.dossier }
            })
          } else {
            await router.push({
              name: 'dossier_light_form_information_route',
              params: { id: response.data.dossier }
            })
          }
        }
      })
      .catch((reason) => {
        console.error('storeNewDossier', reason)
      })
  },

  storeNewPaymentToDossier: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      let url = `dossier/${payload.dossier_id}/payment`
      apiClient
        .post(apiPath(url), payload.payment)
        .then((response) => {
          if (response.status === 200) {
            processSuccessCallback(payload)
            commit('setDossier', response.data.dossier)
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  // #endregion

  // #region update

  updateDossierStatus({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierStatusController.put({ dossier: payload.dossier_id }),
          payload.form_data
        )
        .then((response) => {
          commit('auth/setErrors', {}, { root: true })
          commit('setDossier', response.data.dossier)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async updateDossierComplete({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateDossierStatusCompletedController.put({
            dossier: payload.dossier_id
          }),
          payload.form_data
        )
        .then((response) => {
          if (response.status === 200) {
            commit('auth/setErrors', {}, { root: true })
            resolve(response.data)
            processSuccessCallback(payload)
          }
        })
        .catch((reason) => {
          if (payload.errorCallback) {
            payload.errorCallback()
          }
        })
    })
  },

  async updateDossier({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .put(`/api/dossier/${payload.form_data.id}`, payload.form_data.dossier)
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
          await commit('setDossier', response.data.dossier)
        }
      })
      .catch((reason) => {
        console.error('updateDossier', reason)
      })
  },

  updateDossierPaymentById: ({ commit }, payload) => {
    commit('auth/setErrors', base_errors, { root: true })
    return new Promise((resolve, reject) => {
      let url = `dossier/${payload.dossier_id}/payment/${payload.payment_id}`
      apiClient
        .put(apiPath(url), payload.payment)
        .then((response) => {
          commit('setDossier', response.data.dossier)
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  async runAutomationDossier({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .route(
        RunAutomationDossierController.put({
          dossier: payload.dossier_id,
          automation: payload.automation_id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
          await commit('setDossier', response.data.dossier)
        }
      })
      .catch((reason) => {
        console.error('runAutomationDossier', reason)
      })
  },

  assignConcessionToDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AssignGravePlotToDossierController.put({
            dossier: payload.dossier_id,
            gravePlot: payload.grave_plot_id
          }),
          {
            model_id: payload.model_id,
            model_type: payload.model_type
          }
        )
        .then((response) => {
          commit('setDossier', response.data.dossier)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // #endregion

  // #region delete
  async deleteDossierById({ commit }, payload) {
    await apiClient
      .delete(`/api/dossier/${payload.dossier_id}`)
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
          await commit('setDossierList', response.data.dossiers)
        }
      })
      .catch((reason) => {
        console.error('deleteDossierById', reason)
      })
  },

  async undoDeleteDossierById({ commit }, payload) {
    await apiClient
      .get(`/api/dossier/undo-delete/${payload.dossier_id}`)
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
          await commit('setDossierList', response.data.dossiers)
        }
      })
      .catch((reason) => {
        console.error('undoDeleteDossierById', reason)
      })
  },

  unlinkPayment: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UnlinkDossierPaymentController.post({
            dossier: payload.dossier_id,
            payment: payload.payment_id
          }),
          {
            deletion_type: payload.deletion_type
          }
        )
        .then((response) => {
          commit('setDossier', response.data.dossier)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchCondolenceDossierList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchCondolencesDossierByIdController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchDossierStatusSummary({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetDossierStatusIndicatorsController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          commit('setStatusSummary', response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async fetchEventTasksForDossier({ commit }, { event_id }) {
    await apiClient
      .route(GetEventByIdController.get({ event: event_id }))
      .then((response) => {
        if (response.data?.event?.tasks !== undefined) {
          commit('setParentDossierTasks', {
            parent_type: 'App\\Models\\Event',
            parent_id: event_id,
            task_dossiers: response.data.event.tasks
          })
        }
      })
      .catch((reason) => {
        console.error('fetchEventTasksForDossier', reason)
      })
  },

  async fetchEventItemsForDossier({ commit }, { event_id }) {
    await apiClient
      .route(GetEventByIdController.get({ event: event_id }))
      .then((response) => {
        if (response.data?.event?.items !== undefined) {
          commit('setEventItemsByEventId', {
            eventId: event_id,
            items: response.data.event.items
          })
        }
      })
      .catch((reason) => {
        console.error('fetchEventItemsForDossier', reason)
      })
  }

  // #endregion
}
